export enum WsEvent {
  CustomerUpdated = '.customer.updated',
  DisciplineUpdated = '.discipline.updated',
  BookingCreated = '.booking.created',
  BookingUpdated = '.booking.updated',
  BookingDeleted = '.booking.deleted',
  LessonRefreshed = '.lesson.refreshed',
  AssessmentCreated = '.assessment.created',
  FilesUpdated = '.file-pack.uploaded',
  SubscriptionRetryFailed = '.subscription.retry.failed',
  SubscriptionRetrySuccessful = '.subscription.retry.successful',
  ProgressReportCreated = '.progress-report.created',
}
